<script lang="ts">
import { PropType } from 'vue';

import RouteLink from '@/components/base/RouteLink.vue';
import type { ShipmentInfo } from '@/utils/orderDetails';

export default {
  name: 'ShipmentInfo',
  props: {
    orderExternalId: { required: true, type: Number },
    shipmentInfo: { required: true, type: Object as PropType<ShipmentInfo> },
  },
  components: {
    RouteLink,
  },
};
</script>

<template>
  <div>
    <h3 class="text-lg heading-3">Shipping Details:</h3>
    <p v-if="shipmentInfo.method" class="mt-5 escape-legacy">
      <b>Shipping method:</b> {{ shipmentInfo.method }}<br />
    </p>
    <p v-if="shipmentInfo.ship_date" class="escape-legacy">
      <b>Ship date:</b> {{ shipmentInfo.ship_date }}<br />
    </p>
    <p v-if="shipmentInfo.arrival_date" class="escape-legacy">
      <b>Est. delivery date:</b> {{ shipmentInfo.arrival_date }}
      <br />
    </p>
    <p class="escape-legacy">
      <b>Track shipment: </b>
      <RouteLink
        :to="`/orders/${orderExternalId}/track?postalCode=${shipmentInfo.address.postal_code}`"
        >Shipment {{ orderExternalId }}
      </RouteLink>
      <br />
    </p>
    <p role="alert" v-if="shipmentInfo.meltable">
      <b class="text-nuts-red-800">Meltable</b> (shipped in heat-resistant packaging)
      <br />
    </p>
  </div>
</template>
